import { TypesProvider } from '../contexts';
import { useAutoshipTypes } from '../hooks/useAutoshipTypes';
import { StateContainer } from './StateContainer';
import { AutoshipWizard } from '~/AutoshipWizard';

export const AutoshipContainer = ({ product }: { product?: string }) => {
  const { data, error } = useAutoshipTypes(product);

  const isLoading = !data && !error;

  return (
    <TypesProvider value={{ types: data?.collection ?? [], isLoading }}>
      <StateContainer>
        <AutoshipWizard />
      </StateContainer>
    </TypesProvider>
  );
};
